module.exports = __webpack_public_path__ + "static/media/8. Badam Bites Cookies 300g.d728a9c9.jpg";